export const faqs = [
  {
    question: '蘑菇视频App是否免费？',
    answer: '蘑菇视频App基础功能完全免费，包括浏览视频、发布作品、点赞评论等。同时提供VIP会员服务，开通后可享受免广告、超清画质、专属滤镜等高级功能。',
  },
  {
    question: '蘑菇视频App在哪里下载？',
    answer: '安卓用户可在华为、小米、OPPO、vivo等官方应用商店搜索「蘑菇视频」下载，也可访问官网直接下载APK安装包。iOS用户在App Store搜索「蘑菇视频」即可下载。请务必通过官方渠道下载，确保安全。',
  },
  {
    question: '蘑菇视频App对手机系统有什么要求？',
    answer: '安卓版本需Android 8.0及以上，iOS版本需iOS 14.0及以上。建议手机运行内存不低于3GB，存储空间不低于200MB，以确保流畅使用体验。',
  },
  {
    question: '如何联系蘑菇视频官方客服？',
    answer: '可通过以下方式联系客服：1）App内「我」→「设置」→「帮助与反馈」→「联系客服」；2）发送邮件至官方客服邮箱；3）关注蘑菇视频官方微博、微信公众号获取帮助。客服工作时间：每日9:00-21:00。',
  },
  {
    question: '蘑菇视频支持哪些视频格式？',
    answer: '蘑菇视频支持主流视频格式的拍摄和上传，包括MP4、MOV、AVI等格式。建议上传1080P及以上分辨率的视频，以获得更好的播放效果。单个视频大小建议不超过500MB。',
  },
  {
    question: '蘑菇视频App是否安全？',
    answer: '蘑菇视频App高度重视用户数据安全和隐私保护，采用业界领先的数据加密技术，严格遵守相关法律法规。我们不会未经用户授权收集或分享个人信息，并定期进行安全审计。',
  },
];